import { useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { Grid } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import CustomizedDialogs from "../../atoms/dialog";
import TabPanel from "../../atoms/tabPanel"
import ClusterletsConfiguration from './ClusterletsConfig'

export default function ClusterletViewSelectorForDashboard({onClose}) {
    console.log("ClusterletViewSelectorForDashboard------------------------2")
    const [value, setValue] = useState(0)

    const handleChange = (e,newValue) => {
        setValue(newValue)
    }

    return (
        <CustomizedDialogs
            open={true}
            title={value == 0 ? 'Select clusterlets to dashboard' : 'Select profiles to dashboard'}
            handleClose={onClose}
        >
        
        <Grid container direction={"row"}>
            <AppBar position="static">   
                <Tabs value={value} onChange={handleChange}>
                <Tab label="Clusterlets" style={{textTransform: 'capitalize'}} />
                <Tab label="Profiles" style={{textTransform: 'capitalize'}} />
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0} style={{width: '100%'}}>
                <ClusterletsConfiguration onClose={onClose}  typeOfClusterlet={[2,3]} />
            </TabPanel>
            <TabPanel value={value} index={1} style={{width: '100%'}}>
                <ClusterletsConfiguration onClose={onClose}  typeOfClusterlet={[6]} />
            </TabPanel>
        </Grid>

        </CustomizedDialogs>
    )

}